export const GET_INVESTOR_TYPE_ATTEMPT = 'GET_INVESTOR_TYPE_ATTEMPT';
export type GET_INVESTOR_TYPE_ATTEMPT = typeof GET_INVESTOR_TYPE_ATTEMPT;

export const GET_INVESTOR_TYPE_SUCCESS = 'GET_INVESTOR_TYPE_SUCCESS';
export type GET_INVESTOR_TYPE_SUCCESS = typeof GET_INVESTOR_TYPE_SUCCESS;

export const GET_INVESTOR_TYPE_FAILURE = 'GET_INVESTOR_TYPE_FAILURE';
export type GET_INVESTOR_TYPE_FAILURE = typeof GET_INVESTOR_TYPE_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investor-type/get/Types.tsx